import styled from "@emotion/styled";
import { ToggleGroup as RadixToggleGroup } from "radix-ui";
import type React from "react";

import { theme } from "@themes/themes";

export interface ToggleGroupItemProps {
  value: string;
  disabled?: boolean;
  children: React.ReactNode;
  "aria-label"?: string;
  "data-testid"?: string;
  className?: string;
  size?: "sm" | "md";
}

export const ToggleGroupItem: React.FC<ToggleGroupItemProps> = ({
  value,
  disabled,
  children,
  size = "md",
  ...rest
}) => (
  <StyledItem disabled={disabled} size={size} value={value} {...rest}>
    {children}
  </StyledItem>
);

const StyledItem = styled(RadixToggleGroup.Item)<{ size: "sm" | "md" }>`
  display: flex;
  align-items: center;
  justify-content: center;

  margin: -1px;

  width: 100%;
  height: ${({ size }) => (size === "sm" ? "24px" : "32px")};

  background: transparent;
  color: ${theme.color("accent-contrast")};

  border: 1px solid transparent;
  border-radius: 8px;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.24px;

  box-shadow: none;
  cursor: pointer;

  transition:
    background 0.15s,
    color 0.15s,
    border 0.15s;
  min-width: ${({ size }) => (size === "sm" ? "24px" : "32px")};

  &[data-state="on"] {
    position: relative;
    z-index: 3;
    background: ${theme.color("gray-2")};
    border: 1px solid ${theme.color("accent-9")};
    border-radius: 8px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
